import { render, staticRenderFns } from "./bulkDomainDeletionModal.vue?vue&type=template&id=78b9493b&scoped=true"
import script from "./bulkDomainDeletionModal.vue?vue&type=script&lang=js"
export * from "./bulkDomainDeletionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b9493b",
  null
  
)

export default component.exports